import { IdSchema } from '@batiflow/contracts';
import { z } from 'zod';

/**
 * Search params of /o/$orgId/chat/$channelId: the message a notification links to (scrolled to and
 * highlighted). An invalid value is simply dropped.
 */
export const ConversationSearchSchema = z.object({
  message: IdSchema.optional().catch(undefined),
});
export type ConversationSearch = z.infer<typeof ConversationSearchSchema>;
